export const COIN_SIZES = Object.freeze([1, 2, 5, 10, 25, 50, 100, 200, 500, 1000]);
